import { TENNAT_API_URL } from '@services/.env'
import { BaseService } from './base.service'
import { by, get, del } from './custom.service'

export class NoticeBoardService extends BaseService {
  // Post endpoints
  // Create post
  static createPost({ post, id }) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_posts`, post, id)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not create notice board post'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Update post
  static updatePost(postId, postData) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_posts`, postData, postId)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not update notice board post'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Get posts
  static getPosts(filters = {}) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_posts/filters`, filters)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not get notice board posts'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Get post by id
  static getPostById(postId) {
    return new Promise((resolve, reject) => {
      return get(`${TENNAT_API_URL}notice_board_posts/${postId}`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not get notice board post'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Deactivate post
  static deactivatePost(postId) {
    return new Promise((resolve, reject) => {
      return del(`${TENNAT_API_URL}notice_board_posts/deactivate`, postId)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not deactivate notice board post'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Post Labels endpoints
  // Create post label
  static createOrUpdatePostLabel({ postLabel, id }) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_labels`, postLabel, id)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not create post label'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Get post labels
  static getPostLabels(filters = {}) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_labels/filters`, filters)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not get post labels'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Delete post label
  static deletePostLabel(postLabelId) {
    return new Promise((resolve, reject) => {
      return del(`${TENNAT_API_URL}notice_board_labels/deactivate`, postLabelId)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not delete post label'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Comments endpoints
  // Get comments
  static getComments(filters = {}) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_comments/filters`, filters)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not get notice board comments'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Create comment
  static createComment({ comment, id }) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_comments`, comment, id)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not create notice board comment'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Update comment
  static updateComment(commentId, commentData) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_comments`, commentData, commentId)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not update notice board comment'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Deactivate comment
  static deactivateComment(commentId) {
    return new Promise((resolve, reject) => {
      return del(`${TENNAT_API_URL}notice_board_comments/deactivate`, commentId)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not deactivate notice board comment'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Reply endpoints
  // Create reply
  static createReply(payload) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_comment_replies`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not create notice board reply'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  // Like a post or comment or reply
  static likePostOrCommentOrReply(payload) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}notice_board_likes`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
}
